// src/pages/Register.js
import React, { useState } from "react";
import { register } from "../api/authApi";
import { saveToken } from "../utils/auth";
import { useNavigate, Link } from "react-router-dom";
import "./Auth.css";

const Register = () => {
  const [form, setForm] = useState({
    username: "",
    email: "",
    phone: "",
    password: "",
  });
  const [msg, setMsg] = useState("");
  const navigate = useNavigate();

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMsg("");

    try {
      console.log("Sending to backend:", form);
      const res = await register(form);
      saveToken(res.data.token);
      setMsg("Registered successfully!");
      navigate("/");
    } catch (err) {
      console.error(err);
      setMsg(err.response?.data?.message || "Registration failed");
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <h2>Create Account</h2>
        <form onSubmit={handleSubmit} className="auth-form">
          <label>Username</label>
          <input
            name="username"
            value={form.username}
            onChange={handleChange}
            placeholder="Enter username"
            required
          />
          <label>Email</label>
          <input
            type="email"
            name="email"
            value={form.email}
            onChange={handleChange}
            placeholder="Enter email"
            required
          />
          <label>Phone (optional)</label>
          <input
            type="tel"
            name="phone"
            value={form.phone}
            onChange={handleChange}
            placeholder="Enter phone number"
          />
          <label>Password</label>
          <input
            type="password"
            name="password"
            value={form.password}
            onChange={handleChange}
            placeholder="Enter password"
            required
          />
          <button type="submit" className="auth-btn">
            Register
          </button>
        </form>
        {msg && (
          <p
            className={`auth-msg ${
              msg.includes("success") ? "success" : "error"
            }`}
          >
            {msg}
          </p>
        )}
        <p className="auth-footer">
          Already have an account? <Link to="/login">Login</Link>
        </p>
      </div>
    </div>
  );
};

export default Register;
